export const genderOptions = [
    { value: 'female', label: 'Female' },
    { value: 'male', label: 'Male' },
    { value: 'other', label: 'Other' }
];

// Marital options:

export const maritalOptions = [
    { value: 'single', label: 'Single' },
    { value: 'married', label: 'Married' },
    { value: 'divorced', label: 'Divorced' },
    { value: 'widowed', label: 'Widowed' }
];

// Language options:
export const languageOptions =
    [
        { label: 'English', value: 'english' },
        { label: 'Hindi', value: 'hindi' },
        { label: 'Tamil', value: 'tamil' },
        { label: 'Telugu', value: 'telugu' }
    ]

// levelOptions:
export const fluencyOptions = [
    { label: 'Basic', value: 'basic' },
    { label: 'Conversational', value: 'conversational' },
    { label: 'Fluent', value: 'fluent' },
    { label: 'Native', value: 'native' }
];

export const gradeOptions = [
    { value: "CGPA", label: "CGPA" },
    { value: "Percentage", label: "Percentage" },
];

export const mode = [
    { value: "full-time", label: "Full-time" },
    { value: "part-time", label: "Part-time" },
    { value: "online", label: "Online" },
    { value: "hybrid", label: "Hybrid" }
];

